import { Pipe, PipeTransform } from '@angular/core';

import { AnyValues } from '../interfaces/undetermined';

@Pipe({ name: 'getObjectProperties' })
export class GetObjectPropertiesPipe implements PipeTransform {

  /* transform(): Pipe que devuelve las propiedades de un objeto
    value: Cualquier objeto con o sin propiedades
  */
  transform = (value: AnyValues, type = 'keys'): string[] => typeof value === 'object' ? (type === 'keys' ? Object.keys(value || {}) : (type === 'values' ? Object.values(value || {}) : Object.entries(value || {}))) : [];

}
